import React, {useEffect, useState} from "react";
import {useFormikContext} from "formik";
import Button from "@mui/material/Button";

/**
 * Renders a FormikSubmitButton component.
 *
 * @param {Object} props - The properties for the component.
 * @param {boolean} props.disabled - Whether the button is disabled.
 * @param {ReactNode} props.children - The content of the button.
 * @param {...any} props.props - Additional properties to be spread on the button.
 * @return {JSX.Element} The rendered FormikSubmitButton component.
 */
export const FormikSubmitButton = ({disabled, children, ...props}) => {
    const {submitForm, isSubmitting, isValid} = useFormikContext();
    const [submittingState, setSubmittingState] = useState(false);

    useEffect(() => {
        if (isSubmitting) {
            setSubmittingState(true);
        } else {
            setSubmittingState(false);
        }
    }, [isSubmitting]);

    return (
        <>
            <Button sx={{marginBottom: 2, marginTop: 2, marginLeft: 1}}
                    variant="contained"
                    color="primary"
                    onClick={async (values) => await submitForm(values)}
                    loading={submittingState}
                    loadingPosition={"start"}
                    disabled={submittingState || !isValid || disabled}
                    {...props}
            >
                {children}
            </Button>
        </>
    );
};
